import { Skeleton } from '@synoptic/ui-kit/skeleton/skeleton.tsx';
import { LayoutCard } from '@/components/layout/card.tsx';
import {
  fallBackContainer,
  freeStreamBannerFooter,
  streamBannerContent,
} from './stream-banner.css.ts';

export const StreamBannerFallback = () => (
  <LayoutCard className={fallBackContainer}>
    <div className={streamBannerContent} style={{ gap: 15 }}>
      <Skeleton height={20} width={200} />
      <Skeleton height={30} width={250} />
      <Skeleton height={20} width={200} />
      <Skeleton radius={30} height={30} width={330} />
    </div>
    <div
      className={freeStreamBannerFooter}
      style={{ justifyContent: 'space-between' }}
    >
      <Skeleton radius={30} height={30} width={330} />
      <Skeleton radius={8} height={40} width={100} />
    </div>
  </LayoutCard>
);
